module.exports = __webpack_public_path__ + "assets/img/5c8d4aa80c2739b0eab6cf93bb94f6d5.png";